import {SelectItem} from 'primeng/api';

import {PageResponse} from '..';

export enum ClientfileTypes {
  DRIVER = 'DRIVER',
  RUNTIME = 'RUNTIME',
  LAUNCHER = 'LAUNCHER',
  UPDATER = 'UPDATER',
  REPORTER = 'REPORTER'
}

export class CLientfileConfig {
  key: string;
  value: string;
  new = true;
}

export class Clientfile {
  id?: string;
  name?: string;
  data?: any;
  type?: ClientfileTypes;
  majorVersion?: string;
  minorVersion?: string;
  patchVersion?: string;
  buildNumber?: string;
  status?: string;
  creationDate?: string;
  modifyDate?: string;
  config: CLientfileConfig[];

  getAvailableFileTypes(): SelectItem[] {
    return [
      {label: 'DRIVER', value: ClientfileTypes.DRIVER},
      {label: 'RUNTIME', value: ClientfileTypes.RUNTIME},
      {label: 'LAUNCHER', value: ClientfileTypes.LAUNCHER},
      {label: 'UPDATER', value: ClientfileTypes.UPDATER},
      {label: 'REPORTER', value: ClientfileTypes.REPORTER}
    ];
  }
}

export class ClientfileResponse extends PageResponse {
  content: Clientfile[];
}


